import { FormControl, InputLabel, LinearProgress, MenuItem, Select, TextField, Button, IconButton, Icon, InputAdornment, FormControlLabel, Checkbox, Switch, CircularProgress, Chip } from '@material-ui/core';
import GuiaProductos from '../GuiaProductosNew'
import AutocompleteAsyncrono from '../../../components/Autocomplete';
import React, { useEffect, useState } from 'react'
import CobroServicios from '../../Catalogos/clientes/precios/cobroServicios';
import "./Documentacion.css";
import Http from '../../../Http';
import Toast from 'react-hot-toast';

export default function DetallesNew(props) {
  const { guia, priceInfo, onAddPaquete, onPaqueteChange, onPaqueteDelete, onProductosChange, onSaveGuia, setPrecio, loadingSave, onSelectManifiesto, addCitaEAD, calculate } = props;
  const [showDetailProduct, setShowDetailProduct] = useState(true);
  const [calculating, setCalculating] = useState(false);
  const [nuevaRemisionInput, setNuevaRemisionInput] = useState('');
  const [validatingRemision, setValidatingRemision] = useState(false);

  const requiereRemisiones = Boolean(
    guia.cliente?.cliente_requiere_remisiones_entrega ||
    guia.cliente?.cliente_manifiestos ||
    guia.cliente?.cliente === '101573' ||
    props.cliente?.cliente_requiere_remisiones_entrega ||
    props.cliente?.cliente_manifiestos ||
    props.cliente?.cliente === '101573'
  );

  const onAddRemision = async () => {
    if (!nuevaRemisionInput || !nuevaRemisionInput.trim()) return;
    const remisionesTokens = nuevaRemisionInput
      .split(/[,\s]+/)
      .map(r => r.trim())
      .filter(r => r.length > 0);

    if (remisionesTokens.length === 0) return;

    const idCliente = guia.g_id_cliente || guia.cliente?.id || props.cliente?.id;

    if (requiereRemisiones && idCliente) {
      setValidatingRemision(true);
      try {
        const validas = [];
        for (const token of remisionesTokens) {
          const res = await Http.post('cliente-manifiesto/validar-remision', {
            id_cliente: idCliente,
            remision: token,
            id_guia: guia.id || guia.id_guia
          });
          if (res && res.error) {
            Toast.error(res.errMsg || res.message || `Error con la remisión "${token}"`);
          } else {
            validas.push(token);
          }
        }
        if (validas.length > 0) {
          const actual = guia.remisiones_nuevas || [];
          const actualizadas = Array.from(new Set([...actual, ...validas]));
          if (props.onGuiaChange) {
            props.onGuiaChange(actualizadas, 'remisiones_nuevas');
          } else {
            guia.remisiones_nuevas = actualizadas;
            if (!guia.g_observaciones || !`${guia.g_observaciones}`.trim().length) {
              guia.g_observaciones = actualizadas.join(', ');
            }
          }
          Toast.success(`${validas.length} remisión(es) agregada(s)`);
        }
      } catch (err) {
        console.error('Error al validar remisión', err);
        Toast.error('Error al validar la remisión con el servidor');
      } finally {
        setValidatingRemision(false);
      }
    } else {
      const actual = guia.remisiones_nuevas || [];
      const actualizadas = Array.from(new Set([...actual, ...remisionesTokens]));
      if (props.onGuiaChange) {
        props.onGuiaChange(actualizadas, 'remisiones_nuevas');
      } else {
        guia.remisiones_nuevas = actualizadas;
        if (!guia.g_observaciones || !`${guia.g_observaciones}`.trim().length) {
          guia.g_observaciones = actualizadas.join(', ');
        }
      }
    }
    setNuevaRemisionInput('');
  };

  const onRemoveRemision = (indexToRemove) => {
    const actual = (guia.remisiones_nuevas || []).filter((_, i) => i !== indexToRemove);
    if (props.onGuiaChange) {
      props.onGuiaChange(actual, 'remisiones_nuevas');
    } else {
      guia.remisiones_nuevas = actual;
    }
  };

  let currentEmbalaje = props.embalajes.filter(e => e.id_embalaje_grupo <= guia.id_grupo_embalaje)

  useEffect(() => {
    if (guia.paquetes && guia.paquetes.length > 0 && !guia.g_costo_total && Number(guia.g_id_tipo_precio) !== 3 && Number(guia.g_id_tipo_precio) !== 4 && !!calculate) {
      onCalculate();
    }
  }, [])

  /* useEffect(() => {
    console.log(guia.cita_ead);
    if (guia.paquetes && guia.paquetes.length > 0 && !!calculate) {
      onCalculate();
    }
  }, [guia.cita_ead]) */

  const onCalculate = async (servicios) => {
    setCalculating(true)
    try {
      let Res = await Http.post("guia/precio", { guia, paquetes: guia.paquetes, serviciosIncluidos: servicios || guia.servicios_incluidos });
      if (!Res.error) { setPrecio(Res.data) }
      if (Res.error) { Toast.error('Error inesperado al calcular el precio, intente de nuevo') }
    } catch (error) {
      Toast.error('Error al calcular el precio, intente de nuevo')
    }
    setCalculating(false)
  };

  const paqueteOnBlur = () => {
    const validFields = guia.paquetes.every((paquete) =>
      paquete.gp_cantidad !== ""
      && paquete.gp_id_embalaje !== ""
      && paquete.gp_peso !== ""
    );
    if (validFields) {
      onCalculate();
    }
  };

  const onGuiaChange = (value, key, trigger = true) => {
    props.onGuiaChange(value, key);
    if (trigger && ["g_id_tipo_precio", 'servicios_incluidos', 'g_autoservicio', 'g_almacenaje', 'g_completo'].includes(key) && guia.paquetes.length > 0) {
      onCalculate();
    }
  }

  const onCitaEADChange = (servicios, cita_ead) => {
    addCitaEAD(servicios, cita_ead);
    onCalculate(servicios);
  }

  const disabled = calculating || props.disabled;

  return (<div style={{ padding: 15 }}>
    <div className="row">
      <div className="col-12 col-sm-6">
        <FormControl variant="outlined" className="form-field">
          <InputLabel>Tipo de Precio</InputLabel>
          <Select
            disabled={disabled ? disabled : false}
            value={guia?.g_id_tipo_precio}
            onChange={(e, v) => { onGuiaChange(e.target.value, "g_id_tipo_precio") }}
          >
            <MenuItem value={"1"}>Consolidado</MenuItem>
            <MenuItem value={"2"}>Porcentaje</MenuItem>
            <MenuItem value={"3"}>Devolución</MenuItem>
            <MenuItem value={"4"}>Guia Interna</MenuItem>
          </Select>
        </FormControl>
      </div>
      {(guia.g_id_tipo_precio == "2") && (
        <div className="col-sm-6">
          <FormControl variant="outlined" className="form-field">
            <TextField
              disabled={disabled ? disabled : false}
              value={guia?.g_tipo_precio_valor}
              onChange={(e) => onGuiaChange(e.target.value, "g_tipo_precio_valor")}
              type="number"
              label="Valor Factura"
              variant="outlined"
            />
          </FormControl>
        </div>
      )}
      <div className="col-12 col-sm-6">
        <FormControl variant="outlined" className="form-field">
          <InputLabel>Grupo de Embalaje</InputLabel>
          <Select
            disabled={disabled}
            value={guia?.id_grupo_embalaje || ""}
            onChange={(e, v) => { onGuiaChange(e.target.value, "id_grupo_embalaje") }}
          >
            {props?.embalaje_grupos.map((carga, i) => (
              <MenuItem value={carga.id} key={`grupo-${i}`}>
                {carga.grupo}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>

    <div style={{ textAlign: "right", paddingTop: 10, paddingBottom: 10 }}>
      {calculating && (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <div>Calculando Precio</div>
          <div style={{ width: "100%" }}>
            <LinearProgress />
          </div>
        </div>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={onAddPaquete}
        disabled={disabled}
      >
        Agregar paquete
      </Button>
    </div>

    <div className="guia-detalles">
      <h3>Detalle de Paquetes</h3>
      {guia.paquetes.map((paquete, index) => (
        <div className="row paquete-row" key={`paquete-row-${index}`}>
          <div className="col-sm-2">
            <FormControl variant="outlined" className="form-field">
              <TextField
                label="Cantidad"
                type="number"
                value={paquete["gp_cantidad"]}
                onBlur={(e) => { paqueteOnBlur(); }}
                onChange={(e) => { onPaqueteChange(index, "gp_cantidad", e.target.value) }}
                variant="outlined"
                inputProps={{ min: 0 }}
                disabled={disabled ? disabled : false}
              />
            </FormControl>
          </div>
          <div className="col-sm-3">
            <AutocompleteAsyncrono
              disabled={disabled ? disabled : false}
              label={`Unidad`}
              value={paquete["gp_id_unidad"]}
              onChange={(e) => { onPaqueteChange(index, "gp_id_unidad", e.target.value) }}
              apiUrl={'search/unidad'}
              options={paquete["unidad_options"] || []}
              onOptionsChange={(e) => { onPaqueteChange(index, "unidad_options", e) }}
            />
          </div>
          <div className="col-sm-3">
            <AutocompleteAsyncrono
              disabled={disabled ? disabled : false}
              label={`Producto`}
              value={paquete["gp_id_producto"]}
              onChange={(e) => { onPaqueteChange(index, "gp_id_producto", e.target.value) }}
              apiUrl={'search/producto'}
              options={paquete["producto_options"] || []}
              onOptionsChange={(e) => { onPaqueteChange(index, "producto_options", e) }}
            />
          </div>
          <div className="col-sm-3">
            <FormControl variant="outlined" className="form-field">
              <InputLabel>Embalaje</InputLabel>
              <Select
                disabled={disabled ? disabled : false}
                value={paquete["gp_id_embalaje"]}
                onChange={(e) => { onPaqueteChange(index, "gp_id_embalaje", e.target.value) }}
                onBlur={(e) => { paqueteOnBlur(); }}
              >
                {currentEmbalaje.map((embalaje, i) => (
                  <MenuItem value={embalaje.id} key={i}>
                    {embalaje.embalaje}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-sm-3">
            <FormControl variant="outlined" className="form-field">
              <TextField
                disabled={disabled ? disabled : false}
                label="Descripción"
                variant="outlined"
                value={paquete["gp_descripcion"]}
                onChange={(e) => { onPaqueteChange(index, "gp_descripcion", e.target.value) }}
              />
            </FormControl>
          </div>
          <div className="col-sm-2">
            <FormControl variant="outlined" className="form-field">
              <TextField
                disabled={disabled ? disabled : false}
                value={paquete["gp_peso"]}
                onChange={(e) => { onPaqueteChange(index, "gp_peso", e.target.value) }}
                onBlur={(e) => { paqueteOnBlur(); }}
                type="number"
                label="Peso(kg)"
                variant="outlined"
                inputProps={{ min: 0 }}
              />
            </FormControl>
          </div>
          <div className="col-sm-2">
            <FormControl variant="outlined" className="form-field">
              <TextField
                disabled={disabled ? disabled : false}
                value={paquete["gp_precio"]}
                readOnly
                type="number"
                label="Precio"
                variant="outlined"
              />
            </FormControl>
          </div>
          <div className="col-sm-2">
            <FormControl variant="outlined" className="form-field">
              <TextField
                disabled={disabled ? disabled : false}
                value={paquete["gp_tipo_cobro"]}
                readOnly
                label="Tipo de cobro"
                variant="outlined"
              />
            </FormControl>
          </div>
          <div className="col-sm-1">
            <IconButton
              disabled={disabled ? disabled : false}
              onClick={() => {
                onPaqueteDelete(index);
              }}
            >
              <Icon>remove_circle</Icon>
            </IconButton>
          </div>
        </div>
      ))}
      {guia.paquetes.length === 0 && (
        <span style={{ textAlign: "center" }}>NO HAY PAQUETES</span>
      )}
    </div>
    <div
      style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
    >
      <Button
        color="secondary"
        variant='contained'
        style={{ marginBottom: 10 }}
        onClick={() => { setShowDetailProduct(!showDetailProduct) }}
      >
        Detallar Productos
      </Button>
    </div>
    {showDetailProduct && (
      <div className="preguia-detalles-paquetes">
        <GuiaProductos
          idguia={guia.id}
          productos={guia.productos}
          onProductosChange={onProductosChange}
        />
      </div>
    )}

    <div className="row">
      <div className="col-sm-12">
        <div className="row row-more-info">
          <div className="col-12 col-sm-4">
            <TextField
              disabled={disabled ? disabled : false}
              value={guia?.g_volumen_largo}
              onChange={(e) => onGuiaChange(e.target.value, "g_id_tipo_precio")}
              type="number"
              label="Volumen-largo"
              variant="outlined"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">cm</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="col-12 col-sm-4">
            <TextField
              disabled={disabled ? disabled : false}
              value={guia?.g_volumen_alto}
              onChange={(e) =>
                onGuiaChange(e.target.value, "g_volumen_alto")
              }
              type="number"
              label="Volumen-alto"
              variant="outlined"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">cm</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="col-12 col-sm-4">
            <TextField
              disabled={disabled ? disabled : false}
              value={guia?.g_volumen_ancho}
              onChange={(e) =>
                onGuiaChange(e.target.value, "g_volumen_ancho")
              }
              type="number"
              label="Volumen-ancho"
              variant="outlined"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">cm</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="col-12 col-sm-4">
            <TextField
              disabled={disabled ? disabled : false}
              value={guia?.g_peso_volumetrico}
              onChange={(e) =>
                onGuiaChange(e.target.value, "g_peso_volumetrico")
              }
              type="number"
              label="Peso Volumetrico"
              variant="outlined"
              fullWidth
            />
          </div>
          <div className="col-12 col-sm-4">
            <TextField
              disabled={true}
              readOnly
              value={guia?.g_peso_real}
              onChange={(e) =>
                onGuiaChange(e.target.value, "g_peso_real")
              }
              type="number"
              label="Peso Real"
              variant="outlined"
              fullWidth
            />
          </div>
          <div className="col-12 col-sm-4">
            <TextField
              disabled={true}
              readOnly
              value={guia?.g_piezas}
              onChange={(e) =>
                onGuiaChange(e.target.value, "g_piezas")
              }
              type="number"
              label="Piezas"
              variant="outlined"
              fullWidth
            />
          </div>
          <div className="col-6">
            <TextField
              disabled={disabled ? disabled : false}
              value={guia?.g_observaciones}
              onChange={(e) =>
                onGuiaChange(e.target.value, "g_observaciones")
              }
              label="Observaciones"
              multiline
              fullWidth
              minRows="2"
              variant="outlined"
            />
          </div>
          <div className="col-6">
            <TextField
              disabled={disabled ? disabled : false}
              value={guia?.g_dimensiones}
              onChange={(e) =>
                onGuiaChange(e.target.value, "g_dimensiones")
              }
              label="Dimensiones"
              multiline
              fullWidth
              minRows="2"
              variant="outlined"
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12">
        <div className="row">
          <div className="col-6">
            <h3>Tipo de Servicio</h3>
            <FormControlLabel
              control={
                <Switch
                  disabled={disabled ? disabled : false}
                  checked={!!guia?.g_autoservicio}
                  onChange={(e) =>
                    onGuiaChange(
                      e.target.checked,
                      "g_autoservicio"
                    )
                  }
                  name="g_autoservicio"
                />
              }
              label="Autoservicio"
            />
            <FormControlLabel
              control={
                <Switch
                  disabled={disabled ? disabled : false}
                  checked={!!guia?.g_almacenaje}
                  onChange={(e) =>
                    onGuiaChange(
                      e.target.checked,
                      "g_almacenaje"
                    )
                  }
                  name="g_almacenaje"
                />
              }
              label="Almacenaje"
            />

            <FormControlLabel
              control={
                <Switch
                  disabled={disabled ? disabled : false}
                  checked={!!guia?.g_completo}
                  onChange={(e) =>
                    onGuiaChange(
                      e.target.checked,
                      "g_completo"
                    )
                  }
                  name="g_completo"
                />
              }
              label="Completo"
            />
          </div>
        </div>
      </div>

      <div className="col-sm-6 row-more-info">
        <CobroServicios
          title={"Servicios Incluidos"}
          disabled={disabled ? disabled : false}
          disableRecoleccion
          disableFlete
          disableCpac
          inverse
          fillValue
          citaEAD={guia.cita_ead}
          tipoServicios={{ g_autoservicio: guia.g_autoservicio, g_almacenaje: guia.g_almacenaje, g_completo: guia.g_completo }}
          handleOnCobroServicios={(e, trigger) => onGuiaChange(e.especificaciones, 'servicios_incluidos', trigger)}
          tiposListas={props.tipos_cobro}
          listaPreciosServicios={{ especificaciones: guia.servicios_incluidos }}
          handleCitaEAD={(servicios, cita_ead) => onCitaEADChange(servicios, cita_ead)}
        />
      </div>
      <div className="col-sm-6">
        <div className="row row-more-info precios-container">
          {props.tipos_cobro.map((tipoCobro) => (
            <div key={tipoCobro.id} className="col-12 col-sm-6">
              <TextField
                readOnly
                // type="number"
                value={guia[`tipo_${tipoCobro.id}`] || "0"}
                label={tipoCobro.lpt_nombre}
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
              <div className="msg-info">
                <span>
                  {priceInfo[`tipo_${tipoCobro.id}`] &&
                    priceInfo[`tipo_${tipoCobro.id}`].lp &&
                    `Obtenido de: ${priceInfo[`tipo_${tipoCobro.id}`].lp}`}
                </span>
                <span>
                  {priceInfo[`tipo_${tipoCobro.id}`] &&
                    (tipoCobro.id === 1 || tipoCobro.id === 3) &&
                    priceInfo[`tipo_${tipoCobro.id}`].km &&
                    `Kilometros Calculados: ${priceInfo[`tipo_${tipoCobro.id}`].km
                    }`}
                </span>
              </div>
            </div>
          ))}
          <div className="col-12 col-sm-12">
            <TextField
              readOnly
              value={guia["g_costo_subtotal"] || "0"}
              type="number"
              label="Subtotal"
              variant="outlined"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="col-12 col-sm-12">
            <TextField
              readOnly
              value={guia["g_costo_iva"] || "0"}
              type="number"
              label="I.V.A."
              variant="outlined"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="col-12 col-sm-12">
            <TextField
              readOnly
              value={guia["g_costo_retencion"] || "0"}
              type="number"
              label="Retencion."
              variant="outlined"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="col-12 col-sm-12">
            <TextField
              readOnly
              value={guia["g_costo_total"] || "0"}
              type="number"
              label="Total"
              variant="outlined"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </div>


    <div>
      

      {requiereRemisiones && (
        <div style={{ marginTop: 15, marginBottom: 15, padding: 14, border: '1px solid #1976d2', borderRadius: 8, backgroundColor: '#f0f7ff' }}>
          <h4 style={{ margin: '0 0 8px 0', color: '#1565c0', fontSize: 15, fontWeight: 600 }}>
            Captura de Remisiones (3M / Manifiestos de Entrega)
          </h4>
          <p style={{ margin: '0 0 10px 0', color: '#555', fontSize: 13 }}>
            Ingrese los números de remisión que el transportista deberá clasificar en la aplicación móvil:
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Ej. 450001, 450002..."
              value={nuevaRemisionInput}
              onChange={(e) => setNuevaRemisionInput(e.target.value)}
              onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); onAddRemision(); } }}
              style={{ flex: 1, backgroundColor: '#fff' }}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={validatingRemision || disabled}
              onClick={onAddRemision}
            >
              {validatingRemision ? <CircularProgress size={18} color="inherit" /> : '+ Agregar'}
            </Button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, minHeight: 32, alignItems: 'center' }}>
            {(guia.remisiones_nuevas || []).map((rem, idx) => (
              <Chip
                key={idx}
                label={`Remisión: ${rem}`}
                color="primary"
                variant="outlined"
                onDelete={disabled ? undefined : () => onRemoveRemision(idx)}
              />
            ))}
            {(!guia.remisiones_nuevas || guia.remisiones_nuevas.length === 0) && (
              <span style={{ color: '#e65100', fontSize: 13, fontStyle: 'italic' }}>
                * Aviso: No se han capturado remisiones para este cliente. Puede dejarse en blanco si no aplica.
              </span>
            )}
          </div>
        </div>
      )}
    </div>


    <div className="button-container">
      <Button
        disabled={disabled}
        variant="contained"
        color="primary"
        onClick={onSaveGuia}
      >
        {loadingSave && <CircularProgress size={20} color='white' style={{ marginRight: 5 }} />}
        Guardar guía
      </Button>
    </div>
  </div>)
}
